export { Home } from './home'
export { Ajuda } from './ajuda'
export { Simulacao } from './simulacao'
export { Sobre } from './sobre'
export { TermosDeUso } from './termos-de-uso'
export { MedCred } from './medcred'
